import React, { useEffect } from 'react'
import DatePicker from 'react-datepicker'
import Calendar from '../../../assets/images/calendar.png'
import { sendSxpMessage } from '../../../utils/api'
import { CHAT_PROJECT_ID } from '../../../utils/constants'
import KeycloakService from '../../../utils/keycloakService'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { selectSearchValue, setSearchValue } from '../appointmentsSlice'
import { SXP_CHAT } from '../../../utils/roles'
import { create } from '../../Radiology/Constants/constants'
import '../appointments.scss'
import SelectableSearch from '../../../components/SelectableSearch'
import { searchConstant } from '../../../components/constants'

type Props = {
  startDate: Date
  onChange: (date: Date) => void
  rowData: any
}

const AppointmentsFilter = ({ startDate, onChange }: Props) => {
  const dispatch = useAppDispatch()
  const searchValue = useAppSelector(selectSearchValue)
  const createAppointment = async () => {
    if (KeycloakService.hasRole([SXP_CHAT])) {
      await sendSxpMessage(CHAT_PROJECT_ID, '::restart')
      window.chatSendMsg('book', KeycloakService.getUsername())
    }
  }

  const handleSearch = async (p: string, q: string) => {
    if (!p || !q) {
      dispatch(setSearchValue(null))
    } else {
      let queryString: string
      switch (p) {
        case searchConstant?.muhid:
          queryString = searchConstant?.identifier
          break
        case searchConstant?.Name:
          queryString = searchConstant?.name
          break
        case searchConstant?.Mobile:
          queryString = searchConstant?.phone
          break
        default:
          queryString = searchConstant?.unknown
      }
      dispatch(setSearchValue({ type: queryString, value: q }))
    }
  }
  useEffect(() => {
    dispatch(setSearchValue(null))
  }, [dispatch])
  return (
    <div className='text-right appointments-sub-container'>
      <div className='handleCal inline-block'>
        <img alt={'Calendar'} src={Calendar} />
        <DatePicker
          className='datePickerUI'
          placeholderText='DD-MM-YYYY'
          selected={startDate}
          onChange={onChange}
          dateFormat='dd-MM-yyyy'
        />
      </div>
      <SelectableSearch
        items={[
          searchConstant?.muhid,
          searchConstant?.Name,
          searchConstant?.Mobile,
        ]}
        onSearch={handleSearch}
        placeHolder='Enter MUHID,name,mobile'
        inputValue={searchValue?.value ?? ''}
      />

      <button
        className={`btn btn-primaryBtn ${
          KeycloakService.hasRole([SXP_CHAT]) ? '' : 'auth-disabled'
        }`}
        onClick={createAppointment}
      >
        {create}
      </button>
    </div>
  )
}

export default AppointmentsFilter
